/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `petrol` - Petrol
 * * `diesel` - Diesel
 * * `cng` - CNG
 * * `electric` - Electric
 * * `hybrid` - Hybrid
 * * `lpg` - LPG
 */
export type FuelTypeEnum = typeof FuelTypeEnum[keyof typeof FuelTypeEnum];


export const FuelTypeEnum = {
  petrol: 'petrol',
  diesel: 'diesel',
  cng: 'cng',
  electric: 'electric',
  hybrid: 'hybrid',
  lpg: 'lpg',
} as const;
